import { Button, Dialog, DialogActions, DialogContent, DialogContentText } from "@mui/material";

const IntegrationDeleteDialog = ({ open, setOpen, handleDelete, child }) => {
  const handleClose = () => {
    setOpen(false);
  };
  const handleApprove = () => {
    handleDelete();
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Kayıtlı {child.portal} mağazanızı silmek üzeresiniz. Bu işleme devam etmek istiyor
          musunuz?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button className="iyzi-button-gray" onClick={handleClose}>
          Hayır
        </Button>
        <Button className="iyzi-button-red" onClick={handleApprove}>
          Evet
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default IntegrationDeleteDialog;
